import { Transition } from "components/shared/column";
import Loader from "components/shared/loader";
import React from "react";

export default function RunningBgTask(props) {
    return (
        <Transition dir="full">
            <div className="page-book__show book-show">
                <div className="book-show__head">
                    <div className="book-show__close close close--sm" onClick={props.back} />
                    <div className="book-show__title">Отчет</div>
                </div>
                <div className="d-flex justify-content-center align-items-center h-100">
                    <div className="r-item__loader">
                        <Loader />
                    </div>
                    <div className="text-center">
                        Вы уже запустили формирование отчета, <br />
                        дождитесь его завершения или&nbsp;
                        <span className="link" onClick={() => props.removeBgTask({ key: props.activeBgTask.key })}>
                            создайте новый
                        </span>
                    </div>
                </div>
            </div>
        </Transition>
    );
}
